import { ChangeDetectionStrategy, Component } from '@angular/core';
import {PageSubtitleComponent} from "../../../components/page-subtitle/page-subtitle.component";
import {PageTitleLayoutComponent} from "../../../components/page-title-layout/page-title-layout.component";
import {TextPageComponent} from "../../../components/text-page/text-page.component";
import {
    LotteriesAndFooterComponent
} from "../../../components/lotteries-and-footer/lotteries-and-footer.component";

@Component({
  selector: 'homey-common-questions-page',
    imports: [
        PageSubtitleComponent,
        PageTitleLayoutComponent,
        TextPageComponent,
        LotteriesAndFooterComponent
    ],
  templateUrl: './common-questions-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonQuestionsPageComponent {

}
